<header class="container py-2">
  <div class="row flex-nowrap">
    <div class="col-6 col-sm-7 col-md-5 col-lg-4">
      <img src="assets/logos/logo2.png" alt="none" class="img-fluid">
    </div>
    <div class="col-md-5 d-none d-sm-block">
      <h5 class="mt-4 w-100 text-end text-p"> Sistema Estatal de Gestión Escolar</h5>
    </div>
  </div>
</header>
<div class="mb-0 border-top sticky-top bg-light">
  <div class="d-flex display-content-between"> 
    <nav class="nav container d-flex p-0">
      <nav class="navbar-expand-lg m-0 p-0 ">
        <a class="py-3 px-4 text-muted navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <li class="bi bi-list"></li>
      </a>
      </nav>
    </nav>
    <!-- <a class="py-3 px-4 text-muted border-left" href=""> Descargar Pdf</a> -->
  </div>
</div>